import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useQueryConfiguration } from "../../../Common/constants";
import { fetchSensorHistory } from "../../../api";
import { checkForAPISuccess, showErrorToast } from "../../../Common/commonFunctions";
import { Modal } from "react-bootstrap";
import _ from "lodash";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { convertStringDateToLocalTimestamp } from "../../../Common/dateFormater";
import { ClipLoader } from "react-spinners";

const SensorHistory = (props) => {

    const [utils, setUtils] = useState({ history: [] });

    const getColumn = (header, field) =>
        <Column
            className="sensor-history-cell"
            headerClassName="data-table-header"
            field={field}
            header={header}
            body={(row) => <span>{!_.isEmpty(row[field]) ? row[field] : "-"}</span>}
        />

    const getSensorHistory = async () => {
        const { data } = await fetchSensorHistory(props?.sensorId);
        return data;
    }

    const getSensorHistoryQuery = useQuery('get-sensor-history', getSensorHistory, { ...useQueryConfiguration });

    useEffect(() => {
        if(getSensorHistoryQuery.isFetched) {
            if(checkForAPISuccess(getSensorHistoryQuery?.data?.statusCode)) {
                let data = getSensorHistoryQuery?.data?.data;
                setUtils({ ...utils, history: data });
            }
            else {
                showErrorToast(`Failed to fetch sensor history for sensor ${props?.sensorId}`);
            }
            getSensorHistoryQuery.remove();
        }
    }, [getSensorHistoryQuery.isFetched]);

    useEffect(() => {
        getSensorHistoryQuery.refetch();
    }, []);

    return (
        <>
            <Modal className="h-100" backdrop="static" show size="xl" onHide={() => props.close()}>
                <Modal.Header closeButton>
                    <b>Sensor history : {props?.sensorId}</b>
                </Modal.Header>
                <Modal.Body style={{ width: "95%" }} className="h-100">
                    {
                        getSensorHistoryQuery.isFetching ?
                            <div className="w-100 my-5 d-flex justify-center">
                                <ClipLoader color="#075978" />
                            </div>
                                :
                            <>
                                {
                                    !_.isEmpty(utils.history) ?
                                        <DataTable
                                            className="my-4 h-100 w-100"
                                            scrollable
                                            scrollHeight="60vh"
                                            cellClassName={"data-table-cell"}
                                            value={utils.history}
                                            rowClassName={"data-table-row"}
                                            tableClassName="sensor-history-table"
                                        >
                                            { getColumn("Axial", "axial") }
                                            { getColumn("Vertical", "vertical") }
                                            { getColumn("Location", "installLocation") }
                                            { getColumn("Customer", "customerName") }
                                            { getColumn("Profile", "profileName") }
                                            { getColumn("Equipment", "equipmentName") }
                                            { getColumn("Equipment Unit", "equipmentUnitName") }
                                            { getColumn("Component", "componentName") }
                                            { getColumn("Remarks", "remarks") }
                                            { getColumn("Modified By", "modifiedBy") }
                                            <Column
                                                className="sensor-history-cell"
                                                headerClassName="data-table-header"
                                                header="Modified At"
                                                body={(row) => convertStringDateToLocalTimestamp(row.modifiedDateTime, 'MM-dd-YYYY HH:MM')}
                                            />
                                        </DataTable>
                                            :
                                        <center className="my-5">
                                            <b>NO HISTORY FOUND</b>
                                        </center>
                                }
                            </>
                    }
                </Modal.Body>
            </Modal>
        </>
    );
}

export default SensorHistory;